<ng-container *ngIf="model">
  <entity-icon class="icon undraggable" [model]="model.icon" [size]="'16px'"></entity-icon>
  <result-title [model]="title" [selected]="selected" (invoke)="onInvoke()"></result-title>
  <result-subtitle [model]="subtitle" (invoke)="onInvoke()"></result-subtitle>
</ng-container>
